import { useContext } from 'react'
import { AllCommentsContext } from '../../context/allComentsContext'
import styles from './textCommentComponent.module.css'
import { AiFillDelete, AiFillEdit, } from "react-icons/ai";
import { BsFillReplyFill } from "react-icons/bs";
import { Modal } from 'react-bootstrap';
import useTextComment from '../../customHooks/useTextComment';
import { Comment } from '../../interfaces/comment';
interface ITextCommentComponent {
  email: string,
  commentInfo: string,
  parentId: number | null,
  id: number,
  replies: Array<Comment>,
  setdisplayEdit: Function
  setDisplayNewReply: Function
}
const TextCommentComponent = ({ email, commentInfo, id, parentId, setdisplayEdit, setDisplayNewReply, replies }: ITextCommentComponent) => {
  const { removeComment } = useContext(AllCommentsContext);
  const { setShowModal, showModal, deleteComment } = useTextComment(id, removeComment);
  return (
    <div className={`${styles.mainContainer}`}>
      <h1>{email}</h1>
      <p>{commentInfo}</p>
      <div className={`${styles.buttonsContainer}`}>
        <button onClick={() => setdisplayEdit(true)}>  <AiFillEdit color='#fff' size={"20px"} />  </button>
        {
          !parentId ?
            <button onClick={() => setDisplayNewReply(true)}>  <BsFillReplyFill color='#fff' size={"20px"} /> </button>
            : null
        }
        <button onClick={() => setShowModal(true)}> <AiFillDelete color='#fff' size={"20px"} /> </button>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header >
          <Modal.Title>Delete Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            !parentId && replies.length > 0 ?
              "If you delete this comment you delete all its children, are you sure?"
              :
              "Are you sure you want to delete this comment?"
          }
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button onClick={() => deleteComment()}>
            Delete comment
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default TextCommentComponent